import { getKvSyncApi } from '@/api/kvSync'
import kvSyncSubscriber from '@/mqtt/kvSync'

const _state = {}

const kvSyncApi = (rootGetters) => {
  return getKvSyncApi(rootGetters['liveStatsV2/canSubscribeNewKafkaCluster'])
}

const actions = {
  fetchValueByKeyAction: async ({ dispatch, rootGetters }, payload) => {
    if (!payload.key) return
    const resp = await kvSyncApi(rootGetters).getValueByKey(payload.key)
    const { value } = resp.body
    dispatch('updateKeyValueAction', {
      key: payload.key,
      value,
    })
  },

  createKeyValueAction: async ({ rootGetters }, payload) => {
    await kvSyncApi(rootGetters).createKeyValue(payload)
  },

  subscribeKeyAction: async ({ dispatch }, payload) => {
    dispatch('fetchValueByKeyAction', payload)
    kvSyncSubscriber.subscribeKey(payload.key, (topic, message) => {
      dispatch('updateKeyValueAction', {
        key: topic,
        value: message,
      })
      if (payload.callback) {
        payload.callback(topic, message)
      }
    }, payload.options)
  },

  updateKeyValueAction: () => { }, // only declare the action, plugins will listen to this to update state accordingly

  unsubscribeKeyAction(_, payload) {
    kvSyncSubscriber.unsubscribeKey(payload)
  },
}

export default {
  namespaced: true,
  state: _state,
  actions,
}
